import 'focus-visible'
import 'intersection-observer'

IntersectionObserver.prototype.USE_MUTATION_OBSERVER = false
